// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, react: true*/
(function () {
  var init = () => {
    var before_revive = Date.now();
    var started = false;
    var start = () => {
      if (started) return;
      started = true;
      window._reviving_timeout = Date.now() - before_revive;
      require(['/www/hola/pub/root.js'], root => {
        root.init(window.init_prop || {});
      });
    };
    var can_ssr = window.hola_opt ? window.hola_opt.can_ssr : false;
    var is_asap_js_page = window.hola_opt ? window.hola_opt.is_asap_js_page : false;
    if (is_asap_js_page) start();else {
      var start_timeout = setTimeout(() => {
        start();
      }, can_ssr ? 5000 : 0);
      var mouse_move = ev => {
        clearTimeout(start_timeout);
        document.removeEventListener('mousemove', mouse_move);
        window.removeEventListener('click', mouse_move);
        window.removeEventListener('scroll', mouse_move);
        start();
      };
      document.addEventListener('mousemove', mouse_move);
      window.addEventListener('click', mouse_move);
      window.addEventListener('scroll', mouse_move);
    }
  };
  init();
})();